import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslationService } from './modules/i18n';
// language lists
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private release_version:String = "15-04-2026-00"
  public text:number = 8;
  checkAccess: any;
  localInfo :any;
  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private router: Router,
    private meta: Meta
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );
     if (!environment.allowIndexing) {
      this.meta.updateTag({
        name: 'robots',
        content: 'noindex, nofollow'
      });
    }
  }

  ngOnInit() {
    this.modeService.init();
    this.localInfo = JSON.parse(localStorage.getItem('access') || '{}');
    // debugger
    if(this.localInfo && this.localInfo.id){
      // this.router.navigate(['/dashboard']);
    }else{
      this.router.navigate(['/user/login']);
    }
  }
}
